import moment from 'moment';

declare var window: any;
(window as any).global = window;
global.Buffer = global.Buffer || require('buffer').Buffer;
global.process = require('process');

import * as crypto from 'crypto-browserify';

export class CryptoUtils {

  /**
   * private constructor
   */
  private constructor() { }

  /** CryptoUtils的單一實體 */
  private static instance: CryptoUtils;

  private readonly KEY_BYTES = 16;

  private readonly IV_BYTES = 12;

  private readonly AES_KEY = 'OnlineInsuranceProduct';

  private readonly AES_IV = 'firstlife';

  /**
   * 取得 singleton instance
   */
  public static getInstance(): CryptoUtils {
    if (CryptoUtils.instance == null) {
      CryptoUtils.instance = new CryptoUtils();
    }
    return CryptoUtils.instance;
  }

  /**
   * 生成IV
   * @private
   */
  private generateIv() {
    const today = this.AES_IV.padEnd(this.IV_BYTES).toString();
    return new TextEncoder().encode(today);
  }

  enc(str) {
    try {
      const key = crypto.createHash('sha256').update(String(this.AES_KEY)).digest('base64').substr(0, 32);
      const iv = this.generateIv();
      const plainText = typeof str === 'string' ? str : JSON.stringify(str);
      const cipher = crypto.createCipheriv('aes-256-gcm', key, iv);
      const enc1 = cipher.update(plainText, 'utf8');
      const enc2 = cipher.final();
      return Buffer.concat([enc1, enc2, cipher.getAuthTag()]).toString('base64');
    } catch (err) {
      console.log(err);
      return '';
    }
  }

  dec(enc) {
    try {
      const key = crypto.createHash('sha256').update(String(this.AES_KEY)).digest('base64').substr(0, 32);
      const iv = this.generateIv();
      enc = Buffer.from(enc, 'base64');
      const tag = enc.slice(enc.length - this.KEY_BYTES);
      enc = enc.slice(0, enc.length - this.KEY_BYTES);
      const decipher = crypto.createDecipheriv('aes-256-gcm', key, iv);
      decipher.setAuthTag(tag);
      let str = decipher.update(enc, null, 'utf8');
      str += decipher.final('utf8');
      return str;
    } catch (err) {
      console.log(err);
      return {};
    }
  }

}
